import React, { useState } from 'react';
import { TextField, Button, Box, Grid, FormLabel , InputLabel, FormControlLabel , RadioGroup, Radio, MenuItem, Select } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useStyles  from './useStyles'

const PasoTresForm = () => {


    const classes = useStyles();

    const [subTitulo, setSubTitulo] = useState('El Prestador Individual de Salud debe informar el lugar o establecimiento en que habitual y predominantemente ejerce sus funciones.') 

    const handleChangeRegion = (event) => {
      setRegion(event.target.value);
    };
    const handleChangeComuna = (event) => {
      setComuna(event.target.value);
    };

    const [region, setRegion] = React.useState('');
    const [comuna, setComuna] = React.useState('');


    return (


    <>
        {/* aca va el sub titulo del formulario */}
        <FormControl className={classes.formControlComponent} >
          <text style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', textAlign: 'left', paddingLeft: 30}}>{subTitulo}</text>
        </FormControl>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
        <Grid>

          <FormControl className={classes.formControlComponent} >
              <RadioGroup  aria-label="tipotramitacion" name="tramitaciongroup" >
                  <FormControlLabel value="Si" control={<Radio />} label="Selección del Si: Prestador individual actualmente se encuentra ejerciendo su profesión." />
                  <FormControlLabel value="No" control={<Radio />} label="Selección del No: Prestador individual actualmente no se encuentra ejerciendo su profesión." />
                
              </RadioGroup>
          </FormControl>

        

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Rut" size="small"  />
          </FormControl>    

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Nombre del Establecimiento" size="small"  />
          </FormControl>    

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Dirección" size="small"  />
          </FormControl> 


          <FormControl className={classes.formControlComponent} size="small" >
            <InputLabel id="selectlabel"  variant="outlined" >Región</InputLabel>
                <Select
                required
                labelId="regionlabel"
                id="regionselect"
                variant="outlined"
                value={region}
                label="Región"
                onChange={handleChangeRegion}
                >
                    <MenuItem value={0}>Seleccione</MenuItem>
                    <MenuItem value={1}>I Región de Tarapacá</MenuItem>
                    <MenuItem value={2}>II Región de Antofagasta</MenuItem>
                    <MenuItem value={3}>III Región de Atacama</MenuItem>
                </Select>

          </FormControl>
          <FormControl className={classes.formControlComponent} size="small" >

          <InputLabel id="selectlabel"  variant="outlined" >Comuna</InputLabel>
                <Select
                required
                labelId="comunalabel"
                id="comunaselect"
                variant="outlined"
                value={comuna}
                label="Comuna"
                onChange={handleChangeComuna}
                >
                    <MenuItem value={0}>Seleccione</MenuItem>
                    <MenuItem value={1}>Tarapacá</MenuItem>
                    <MenuItem value={2}>Antofagasta</MenuItem>
                    <MenuItem value={3}>Atacama</MenuItem>
                </Select>

          </FormControl>
          <FormControl className={classes.formControlComponent} size="small" >
          </FormControl>


        </Grid>



      </>



  )
}

export default PasoTresForm